module.exports = __webpack_public_path__ + "img/service-about-3.4ee10689.webp";